import request from '@/utils/request'
const apiPath = '/sys/disease'
const diseaseApi = {
  /**
   * 分页查询【疾病列表】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 新增【疾病】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【疾病】
   */
  update(data) {
    return request.put(apiPath, data)
  }
}
export default diseaseApi

